import { animated, useTransition } from "@react-spring/web";
import { useCallback, useEffect } from "react";
import { useAppState } from "../../providers/app-state";
import SingleProduct from "./single-product";

const ProductListDropdown = ({ open, childs, openSidebar }) => {
    const { state, dispatch } = useAppState();

    const onChange = useCallback((_, product) => {
        const arrCopy = Array.from(state.selectedRepairs);
        const index = arrCopy.findIndex(x => x.id === product.id)
        index > -1 ? arrCopy.splice(index, 1) : arrCopy.push(product);
        dispatch({
            key: "selectedRepairs",
            value: arrCopy,
        })
    }, [state.selectedRepairs, dispatch])

    //Removes upsales from the if they're no longer available after customer removes selected product. 
    useEffect(() => {
        const possibleUpsales = state.selectedRepairs.map(r => ([...(r.categoryUpsaleProducts ?? []), ...(r.secondLevelCategoryUpsaleProducts ?? [])])).flat();
        dispatch({
            key: "selectedUpsales",
            value: state.selectedUpsales.filter(r => possibleUpsales.includes(String(r.id)))
        })
    }, [state.selectedRepairs])

    const firstTransition = useTransition(open ? childs : [], {
        trail: 300 / childs.length,
        from: {
            opacity: 0,
            transform: "translateX(-100px)"
        },
        enter: {
            opacity: 1,
            transform: "translateX(0px)"
        },
        leave: {
            opacity: 0,
            transform: "translateX(-100px)"
        }
    })

    return (
        <animated.div>
            {
                firstTransition((style, child) => {
                    return (
                        <animated.div
                            style={style}
                            className="flex flex-wrap shadow-md mb-3 px-5 z-10 bg-white"
                        >
                            <div className="basis-full my-4">
                                <span
                                    className="bg-gray-200 rounded-md p-2 text-xs"
                                >
                                    {child.name}
                                </span>
                            </div>
                            <div
                                className="basis-full divide-y"
                            >
                                {
                                    child.products.sort((a, b) => a.ordering > b.ordering).map((product, i) => {
                                        return (
                                            <SingleProduct
                                                key={i}
                                                product={product}
                                                onChange={onChange}
                                                selectedRepairs={state.selectedRepairs}
                                                openSidebar={openSidebar}
                                                dispatch={dispatch}
                                                dis={Math.random() > 0.5 ? 25 : null}
                                            />
                                        )
                                    })
                                }
                            </div>
                        </animated.div>
                    )
                })
            }
        </animated.div>
    )
}

export default ProductListDropdown;